let clases = Object.freeze({
    Inicial:"0",
    Percepcion:"1",
    Deduccion:"2",
    Acumulado:"3",
    Prestaciones:"4",
    Patronales:"5",
    list: [
        {value: '0', text: 'Calculo Inicial'},
        {value: '1', text: 'Percepción'},
        {value: '2', text: 'Deducción'},
        {value: '3', text: 'Acumulado'},
        {value: '4', text: 'Percepción Informativa'},
        {value: '5', text: 'Deducción Infotmativa'},
    ]
  });
  
  module.exports = { clases }
  